var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"exact-active-class":"active","to":{
      name: _vm.route.name,
      params: { id: _vm.isRandom ? _vm.id : _vm.isSpecific ? 1 : null },
    }}},[_vm._v(_vm._s(_vm.name))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }